import { useStyle } from '@/classify';
import { useOnClickOutside } from '@/common/hooks/useOnClickOutside';
import { useWindowSize } from '@/common/hooks/useWindowSize';
import Popper from '@mui/material/Popper';
import { Form } from 'informed';
import React, { useRef } from 'react';
import { ChevronDown, ChevronUp } from 'react-feather';
import { useIntl } from 'react-intl';
import { Accordion, Section } from '../Accordion';
import Icon from '../Icon';
import FilterList from './FilterList';
import defaultClasses from './filterBlock.module.css';

const FilterBlock = ({
  filterApi,
  filterState,
  filterFrontendInput,
  itemCountToShow,
  group,
  items,
  name,
  onApply = null,
  currentCurrencyCode,
  handleGenerateLinkHref,
}) => {
  const { formatMessage } = useIntl();

  const classes = useStyle(defaultClasses);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const popperRef = useRef(null);

  useOnClickOutside(popperRef, () => {
    setAnchorEl(null);
  });

  const open = Boolean(anchorEl);
  const id = open ? 'popperMenu' : undefined;

  const iconSrc = open ? ChevronUp : ChevronDown;

  const handleClick = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const itemAriaLabel = formatMessage(
    {
      id: 'filterModal.item.ariaLabel',
      defaultMessage: 'Filter products by "{itemName}"',
    },
    {
      itemName: name,
    },
  );

  const toggleItemOptionsAriaLabel = open
    ? formatMessage(
        {
          id: 'filterModal.item.hideOptions',
          defaultMessage: 'Hide "{itemName}" filter item options.',
        },
        {
          itemName: name,
        },
      )
    : formatMessage(
        {
          id: 'filterModal.item.showOptions',
          defaultMessage: 'Show "{itemName}" filter item options.',
        },
        {
          itemName: name,
        },
      );

  const onFilterItemMouseDown = () => {
    setAnchorEl(null);
  };

  const rootClass = open ? classes.rootExpanded : classes.rootCollapsed;

  const iconClass = open ? classes.iconExpanded : classes.iconCollapsed;

  const listsClasses = {
    Color: classes.colorLists,
    Size: classes.sizeLists,
    Price: classes.priceLists,
    'Shop By Styles': classes.shopByStylesLists,
    'Shop By Function': classes.shopByFunctionLists,

    Material: classes.mateialLists,
  };

  const listsClassesDefalut = listsClasses[name] || classes.list;

  // if (group === 'lw_size_shoes_adult') {
  //   console.log(filterState);
  // }

  const list = (
    <Form className={listsClassesDefalut}>
      <FilterList
        filterApi={filterApi}
        filterState={filterState}
        itemCountToShow={itemCountToShow}
        name={name}
        filterFrontendInput={filterFrontendInput}
        group={group}
        items={items}
        onApply={onApply}
        onFilterItemMouseDown={onFilterItemMouseDown}
        currentCurrencyCode={currentCurrencyCode}
        handleGenerateLinkHref={handleGenerateLinkHref}
      />
    </Form>
  );

  const detailClasses = {
    Color: classes.detailClassColor,
    Size: classes.detailClassSize,
    Price: classes.detailClassPrice,
    'Shop By Styles': classes.detailClassStyles,
    'Shop By Function': classes.detailClassFunction,
    Material: classes.detailClassMaterial,
  };

  const detailClass = detailClasses[name] || classes.detailClass;

  const className = `${rootClass} ${detailClass}`;

  const windowSize = useWindowSize();

  const isMobileAndTablet = windowSize.innerWidth <= 960;
  const AccordionClassName = 'border-b border-[#ccc]';
  return (
    <>
      {isMobileAndTablet ? (
        <Accordion
          canOpenMultiple
          classes={{
            root: AccordionClassName,
          }}
        >
          <Section
            customOpenIcon={ChevronUp}
            customCloseIcon={ChevronDown}
            className={classes.section}
            classes={{
              title: classes.accordionTitle,
              title_container: classes.accordionTitleContainer,
              contents_container: classes.accordionContentsContainer2,
            }}
            title={name}
          >
            {list}
          </Section>
        </Accordion>
      ) : (
        // <div className={classes.blockListContainer}>
        //   <span className={classes.headerMobile}>
        //     <span className={classes.nameMobile}>{name}</span>
        //   </span>
        //   {list}
        // </div>
        <li
          className={className}
          aria-label={itemAriaLabel}
          ref={popperRef}
        >
          <button
            aria-describedby={id}
            className={classes.trigger}
            onClick={handleClick}
            type='button'
            aria-expanded={open}
            aria-label={toggleItemOptionsAriaLabel}
          >
            <span className={classes.header}>
              <h2 className={classes.name}>{name}</h2>
              <Icon
                classes={{
                  icon: iconClass,
                }}
                src={iconSrc}
              />
            </span>
          </button>
          <Popper
            id={id}
            open={open}
            placement='bottom-start'
            anchorEl={anchorEl}
            disablePortal
            className={classes.popperBox}
          >
            {list}
          </Popper>
        </li>
      )}
    </>
  );
};

export default FilterBlock;
